import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import financialPlanningImageDesktopWebp from './images/woman-on-the-beach-desktop.webp';
import financialPlanningImageMobileWebp from './images/woman-on-the-beach-mobile.webp';
// Style imports
import { BulletedListStyled } from './styles';

export default () => {
  return (
    <InformationalModule
      // configs
      sectionId='retirement-planning-financial-planning'
      moduleName='financial-planning-module'
      moduleVariation='A'
      subHeadingText={
        <>
          The key to a fulfilling retirement&#63; A smart <WidowBlock>financial plan.</WidowBlock>
        </>
      }
      // column content
      columnContentA={(
        <>
          <Typography nextElement='typography'>
            At Northwestern Mutual, we see a retirement plan as just one part of a comprehensive financial plan. Our advisors will look at every aspect of your life and listen to all of your goals. Once they have your big picture in focus, they&#39;ll bring together multiple financial strategies that include{' '}
            <Link
              id='retirement-planning-financial-planning-investments-link'
              linkUrl='/investments/'
              variant='primaryDeemphasize'>
              investments
            </Link>
            {' '}and{' '}
            <Link
              id='retirement-planning-financial-planning-insurance-link'
              linkUrl='/insurance/'
              variant='primaryDeemphasize'>
              life insurance
            </Link>
            {' '}to create a tailored plan that&#39;s designed to help you:
          </Typography>
          <BulletedListStyled
            bulletedListData={[
              { bulletText: 'Grow your money with the right investments for today and in retirement' },
              { bulletText: 'Make the most of what you have with recommendations for saving and paying down debt' },
              { bulletText: (<>Protect everything you&#39;ve worked so hard for</>) },
            ]}
            bulletType='checkmark'
          />
          <Link
            id='retirement-planning-financial-planning-section-cta'
            linkUrl='/financial-planning/'
            variant='buttonLinkPrimary'>
            Our approach to planning
          </Link>
        </>
      )}
      // image props
      imageAltText='a smiling woman at the beach'
      imageSrcDefault={financialPlanningImageDesktopWebp}
      imageSrcMobile={financialPlanningImageMobileWebp}
    />
  );
};
